import { useState } from "react"
import { ContactFaqType } from "../../types/mainModulTypes"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"

export default function ContactFaq(props: ContactFaqType) {
    const [openIndex, setOpenIndex] = useState<number | null>(null)

    const toggleAccordion = (index: number) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    return (
        <div className="max-w-content mx-auto px-4 lg:px-0">
            <div className="max-w-content-sm mx-auto text-center pb-16">
                <BaseSubheadline label={props.contactFaqHeading} />
                <BaseRichtext content={props.contactFaqText} classProps="pt-2 pb-4" />
            </div>
            <div className="flex flex-col gap-8 w-full">
                {props?.contactFaqBlock?.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => toggleAccordion(index)}
                        className={`py-8 bg-base-200 rounded-default transition-all px-8 w-full ${openIndex === index ? "text-left " : "text-center"
                            }`}>
                        <BaseSubheadline label={item.contactFaqBlockItemQuestion} />
                        {openIndex === index &&
                            <div className="gap-6 text-left">
                                <BaseRichtext content={item?.contactFaqBlockItemAnswer}/>
                            </div>
                        }
                    </div>
                ))}
            </div>
        </div>
    )
}
